angular.module('cimerFrontEndApp').directive("ngAnchor", ['$location',  function ($location) {
    'use strict';
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            // Whenever the attribute changes, we have to update our href state to update the anchor part
            attrs.$observe("ngAnchor", configureHref);
            // Whenever the location changes, we want to update the href value of the link to incorporate the current URL
            scope.$on("$locationChangeSuccess", configureHref);

            // Construct the href from the route and the anchor fragment
            function configureHref() {
                var fragment = attrs.ngAnchor || "";
                // Strip off the leading # to make the concatenation handle inputs that may or may not include the leading #
                if (fragment.charAt(0) === "#") {
                    fragment = fragment.slice(1);
                }
                // Get the route value from the url (after Angular's #)
                var routeValue = "#" + $location.url().split("#").shift();
                // Construct the anchor value
                var fragmentValue = "#" + fragment;
                // Set the href of the link to the full path route#anchor
                attrs.$set("href", routeValue + fragmentValue);
            }
        }
    };
}]);